<template>
<b-container>
    <b-card>
    <b-breadcrumb>
        <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
        <b-breadcrumb-item :to="{name: 'ward-message-list', params: { wardId: wardId, stakeId: stakeId, initState: messageInfo.message_state }}">Ward Messages</b-breadcrumb-item>
        <b-breadcrumb-item active>Notification</b-breadcrumb-item>
    </b-breadcrumb>
    <b-alert variant="warning" :show="ward.twilio_test">
        Ward({{ward.ward_type}}) is currently in test mode, no messages will go out.
    </b-alert>
    <b-row>
        <b-col>
    <h4>Ward({{ward.ward_type}}) Notification</h4>
            </b-col>
            <b-col>
    <b-card v-if="accountBalance !== null && accountBalance !== undefined">
        <h4>Twilio Balance: ${{accountBalance.balance.toFixed(2)}} {{accountBalance.currency}}</h4>
    </b-card>
                </b-col>
    </b-row>
    <b-row class="mt-3">
        <b-col>
        <b-form @submit="onSubmit">
        <b-form-group
            v-if="contactId===null"
            id="input-group-1"
            label="To Organization:"
            label-for="input-1"
            description="Ward Organization"
        >
            <b-form-select
                id="input-1"
                v-model="messageInfo.organization"
                :options="organizations"
                required
                @change="shouldShowLanguages"
            ></b-form-select>
        </b-form-group>
        <b-form-group
            id="input-group-10"
            label="Message State:"
            label-for="input-10"
            description="State message is in">
            <b-form-select
                id="input-1"
                v-model="messageInfo.message_state"
                :options="message_states"
                required
            ></b-form-select>
        </b-form-group>
        <b-form-group
            id="input-group-2"
            description="Message to send to contacts.">
            <label for="input-2">Notification Message: Language [{{ defaultLanguage }}]
                <b-badge pill variant="info" v-if="total_segments>0">Segments: {{total_segments}}</b-badge>
                <b-badge pill variant="secondary" v-if="total_characters>0">Total Chars: {{total_characters}}</b-badge>
                </label>
            <b-form-textarea
              id="textarea"
              v-model="messageInfo.notification_text"
              placeholder="Enter Message to Send"
              rows="6"
              max-rows="6"
              @blur="validateMessageText"
              required
            ></b-form-textarea>
            <b-form-checkbox
                class="mb-3"
                v-model="messageInfo.short_urls"
                v-if="isInRole('canShortUrlMessages')"
                name="short-urls"
                switch>Shorten URLs
            </b-form-checkbox>
        </b-form-group>
        <h5>Message Options</h5>
        <p>Override organization defaults</p>
        <div>
          <b-card no-body>
            <b-tabs card vertical>
                <b-tab title="Custom Greeting" active>
                    <b-card-text>
                        <b-form-group
            id="input-group-3"
            label="Custom Greeting(Optional):"
            label-for="input-3"
            description="Custom Message Greeting to Contacts. Overrides Organization signature">
            <b-form-textarea
              id="textarea"
              v-model="messageInfo.notification_greeting"
              placeholder="Enter custom greeting"
              rows="2"
              max-rows="2"
              @blur="validateMessageText"
            ></b-form-textarea>
        </b-form-group>
                    </b-card-text>
                </b-tab>

                <b-tab title="Custom Signature">
                    <b-card-text>
                        <b-form-group
            id="input-group-4"
            label="Custom Signature(Optional):"
            label-for="input-4"
            description="Custom Signature of message. Overrides Organization signature">
            <b-form-textarea
              id="textarea"
              v-model="messageInfo.notification_signature"
              placeholder="Enter custom signature"
              rows="2"
              max-rows="2"
              @blur="validateMessageText"
            ></b-form-textarea>
        </b-form-group>
                    </b-card-text>
                </b-tab>

                <b-tab title="Schedule Message">
                    <b-card-text>
                        <b-form-group
            id="input-group-5"
            label="Scheduled Delivery On(Optional):"
            description="Schedule the delivery message for a specific date/time"
        >
        <VueCtkDateTimePicker
            :disabled="messageInfo.message_state==='SENT'"
            noLabel
            format="YYYY-MM-DDTHH:mm:ssZ"
            formatted="lll"
            :minDate="scheduleOnlyFuture"
            minuteInterval=5
            v-model="messageInfo.scheduled_delivery_on"/>
        </b-form-group>
                    </b-card-text>
                </b-tab>

                <b-tab title="Extra phone numbers">
                    <b-card-text>
                        <b-form-group
            id="input-group-6"
            label="Extra phone numbers (Optional):"
            description="You can add additional numbers without creating/saving contacts."
            :state="tempContactsState"
        >
        <b-form-tags
            :formatter="formatPhoneNumber"
            :tag-validator="phoneNumberValidator"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            input-id="input-group-6"
            v-model="messageInfo.temp_contacts"
            tag-variant="primary"
            tag-pills
            size="medium"
            separator=" ,;"
            placeholder="Enter phone numbers separate them by comma or semicolon."
            remove-on-delete
            :state="tempContactsState"
            ></b-form-tags>
            <template #invalid-feedback>
              Some of the phone numbers are invalid!
            </template>
            <template #description>
              <div id="tags-validation-help">
                  Phone numbers must be between 10 to 11 digits only and numeric only. Limit of 16 temporary contacts
              </div>
            </template>

        </b-form-group>
                    </b-card-text>
                </b-tab>
                <b-tab title="Additional Languages" v-if="messageInfo.alternate_languages.length > 0">
                    <b-card-text>
                        <b-tabs>
                            <b-tab v-for="(item, idx) of messageInfo.alternate_languages" :title="'Language: ' + item.language" v-bind:key="item.tabName">
                                <b-card-text>
                                    <b-form-group
            id="input-group-2"
            label-for="input-2"
            description="Message to send to contacts.">
            <label for="input-2">Notification Message:
                </label>
            <b-form-textarea
              id="textarea"
              v-model="item.notification_text"
              placeholder="Enter Message to Send"
              rows="6"
              max-rows="6"
            ></b-form-textarea>
            </b-form-group>
            <b-form-group
            id="input-group-3"
            label="Custom Greeting(Optional):"
            label-for="input-3"
            description="Custom Message Greeting to Contacts. Overrides Orginzation greeting">
            <b-form-textarea
              id="textarea"
              v-model="item.notification_greeting"
              placeholder="Enter custom greeting of message."
              rows="2"
              max-rows="2"
              @blur="validateMessageText"
            ></b-form-textarea>
        </b-form-group>

            <b-form-group
            id="input-group-4"
            label="Custom Signature(Optional):"
            label-for="input-4"
            description="Custom Signature of message. Overrides Organization signature">
            <b-form-textarea
              id="textarea"
              v-model="item.notification_signature"
              placeholder="Enter custom signature"
              rows="2"
              max-rows="2"
            ></b-form-textarea>
            </b-form-group>
                                </b-card-text>
                            </b-tab>
                        </b-tabs>


                    </b-card-text>
                </b-tab>
            </b-tabs>
          </b-card>
        </div>



        <b-form-checkbox class="mb-3 mt-3" v-model="messageInfo.confirm_send" name="check-button" switch>
        Confirm Sending Message.
        </b-form-checkbox>
        <b-button
            class="float-right"
            type="submit"
            :disabled="disabledButton"
            v-if="messageInfo.scheduled_delivery_on===null"
            variant="primary">
             <b-spinner small v-if="disabledButton"></b-spinner>
            {{submitText}}</b-button>
            <b-button @click="updateMessageInfo" class="float-left" type="button" variant="secondary" >Update Message</b-button>
    </b-form>
    <b-modal ref="confirmation-modal" :title="messageInfo.confirm_send?'Message Summary':'Preview Summary'">
            <b-alert variant="warning" :show="notificationResponse.message_encoding==='UCS'">
                Message Encoding is UCS which may result in higher text charges,
                Try changing the notification message.
            </b-alert>
            <b-alert variant="warning" :show="messageInfo.short_urls">
                Message preview may contain shorten urls, those are NOT live links, please do not use.
            </b-alert>
            Ward({{ward.ward_type}}) Twilio Balance: <b-badge variant="info">${{notificationResponse.account_balance.toFixed(2)}}</b-badge><br/>
            Organization: {{notificationResponse.organization}}<br/>
            Total Good Sent: {{notificationResponse.total_good}}<br/>
            Total Bad Sent: {{notificationResponse.total_bad}}<br/>
            Previously Sent: {{notificationResponse.previously_sent}}<br/>
            Total Bytes: {{notificationResponse.total_bytes}}<br/>
            Total Segments: {{notificationResponse.total_segments}}<br/>
            Message Encoding: {{notificationResponse.message_encoding}}<br/>
            Sub Total Cost: {{notificationResponse.sub_total_cost}}<br/>
            Carrier Fees: {{notificationResponse.estimated_carrier_fee}}<br/>
            Total Cost: {{notificationResponse.total_cost}}<br/>
            <strong>{{messageInfo.confirm_send?'Message Sample':'Preview Message'}}:</strong>
            <pre>{{notificationResponse.message_preview}}</pre>
    </b-modal>
    <b-modal
        ref="error-modal"
        title="Error trying to send SMS"
        header-bg-variant="danger"
        ok-only>
            <strong>Error Code:{{error.code}}</strong>
            <pre>{{error.detail}}</pre>
    </b-modal>
    </b-col>
    </b-row>
    <b-row>
        <b-col>
  <b-tabs class="mt-3" content-class="mt-3">
    <b-tab title="Events" active><MessageNoteList v-if="messageId!==null && messageInfo.organization !== null" :wardId="wardId" :messageId="messageId" :organization="messageInfo.organization"/>  </b-tab>
    <b-tab :title="'Contacts Sent ('+messageInfo.contacts_sent+')'"><MessageContactList v-if="messageId!==null && messageInfo.organization !== null" :wardId="wardId" :messageId="messageId" :organization="messageInfo.organization" :organizations="organizations"/></b-tab>
  </b-tabs>
    </b-col>
    </b-row>
    </b-card>
</b-container>
</template>
<script>
import { MessageApi } from "@/app/messages/messageApi";
import { WardApi } from "@/app/wards/wardApi";
import MessageNoteList from "@/app/messages/WardMessageNotes";
import MessageContactList from "@/app/messages/WardMessageContacts";
import handleError from "@/errorHandler";
import { userMixin } from "@/mixins/userMixin";
import { organizationMixin } from "@/mixins/organizationMixin";
export default {
    name: "WardMessage",
    components: {MessageNoteList, MessageContactList},
    mixins: [userMixin, organizationMixin],
    props: {
        wardId: {
            type: String,
            required: false,
        },
        messageId: {
            type: String,
            required: false,
            default: null
        },
        stakeId: {
            type:String,
            required: false,
            default: null
        },
        orgCode: {
            type: String,
            required: false,
            default: null
        },
        contactId: {
          type: String,
          required: false,
          default: null
        }
    },
    data () {
        return {
            notGsmMessage: false,
            total_segments: 0,
            total_characters: 0,
            messageInfo: {
                disabledButton: false,
                notificationResponse: {},
                selectedOrganization: null,
                notification_text: null,
                notification_greeting: null,
                costSummary:null,
                costDescription:null,
                confirm_send: false,
                organization: null,
                message_state: null,
                scheduled_delivery_on:null,
                message_id: null,
                notification_signature:null,
                temp_contacts: [],
                total_segments: 0,
                total_contacts: 0,
                short_urls: false,
                alternate_languages: [],
                contact_id: null
            },
            disabledButton: false,
            notificationResponse: {
                account_balance: 0.0
            },
            selectedOrganization: null,
            notificationText: null,
            notificationGreeting: null,
            costSummary:null,
            costDescription:null,
            sendConfirmed: false,
            scheduleDeliveryOn:null,
            tempContactsDirty: false,
            showLanguages: false,
            defaultLanguage: 'None Selected',
            error: {
                code: null,
                detail: null
            },
            message_states: [],
            ward: {
                ward_name: null,
            },
            accountBalance: {
                balance: 0.00
            }
        };
    },
    computed: {
        submitText() {
            let buttonText = "";
            if(!this.disabledButton && !this.messageInfo.confirm_send)
                buttonText = "Preview Notification";
            if(!this.disabledButton && this.messageInfo.confirm_send)
                buttonText = "Send Notifications";
            if(this.disabledButton && this.messageInfo.confirm_send)
                buttonText = "Sending Notification";
            if(this.disabledButton && !this.messageInfo.confirm_send)
                buttonText = "Generating Preview";
            return buttonText;
        },
        scheduleOnlyFuture() {
            if (this.messageInfo.state==='SENT' || this.messageInfo.scheduled_delivery_on!==null) return "";
            let m = this.$moment();
            return m.format().replace("T", " ").slice(0,-6);
        },
        tempContactsState() {
            // Overall component validation state
            return this.tempContactsDirty ? (this.tempContacts.length < 16) : null
        },
        organizations() {
          let activeOrganizations = [];
            if (this.restrictedToOrgs.length > 0){
                activeOrganizations = this.allOrganizations.filter(opt => this.restrictedToOrgs.indexOf(opt.value) !== -1 && !opt.disabled);
            } else {
              activeOrganizations = this.allOrganizations.filter(opt => !opt.disabled);
            }
            if (activeOrganizations !== null && activeOrganizations.length === 0) {

              activeOrganizations.push({
                value: null,
                text: 'No organizations available for your user',
                disabled: true
              })
            }

            return activeOrganizations;
        }
    },
    watch: {
      tempContacts(newValue, oldValue) {
        // Set the dirty flag on first change to the tags array
        this.tempContactsDirty = true
      }
    },
    async mounted() {
        if(this.wardId !== null){
            console.log(this.orgCode);
            this.selectedOrganization = this.orgCode;
            this.messageInfo.selectedOrganization = this.orgCode;
            await this.getOrganizations(this.wardId);
            await this.getAccountBalance();
        }

        this.$store.state.frontEndSettings.message_states.forEach(x=>{
            //console.log(x.value);

            this.message_states.push({
                value: x.value,
                text: x.text,
                disabled: x.value==='SENDING' || x.value==='ERROR'
            })
        });

        if(this.messageId !== null) {
            await this.getMessageInfo();
            await this.validateMessageText();
            await this.getWardDetails();
        }

    },
    methods: {
        phoneNumberValidator(phoneNumber) {
            // Individual tag validator function
            if (isNaN(phoneNumber)) return false;
            return phoneNumber.length === 10 || phoneNumber.length ===11;
        },
        formatPhoneNumber( value ) {
            if (value === null || value === undefined) return;
            let p = value.replace(/\D/g, '');
            let x = p.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            if(p.length==11)
                x = p.match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);
            if(p.length===10){
                return  !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

            }
            if(p.length===11)
                return !x[3] ? x[2] : '(' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '');



        },
        async getAccountBalance(){
            try{
                const { data } = await WardApi.getWardAccountBalance(this.wardId);
                this.accountBalance = data;
            }catch (e) {
                handleError(e, "Failed to get account balance")
            }
        },
        async getWardDetails(){
            try{
                const { data } = await WardApi.getWardDetail(this.wardId);
                this.ward = data.ward;
            }catch (e) {
                handleError(e, "Failed to fetch ward details");
            }
        },
        async getMessageInfo() {
            try {
                const { data } = await MessageApi.getMessage(this.wardId, this.messageId);
                this.messageInfo = data;
                this.shouldShowLanguages();
                //console.log(this.messageInfo);
            } catch (e) {
                handleError(e, "Failed to fetch message info");
            }
        },
        async updateMessageInfo() {
            try {
                const { data } = await MessageApi.updateMessage(this.wardId, this.messageId, this.messageInfo);
                this.$toast.success("Successfully saved message");
                this.$router.push({ name: 'ward-message-list',params: { wardId: this.wardId, initState: this.messageInfo.message_state}});

            } catch (e) {
                handleError(e, "Failed to update message");
            }

        },
        async onSubmit(event) {
            event.preventDefault();
            let dataToSend = {
                ward_id: this.wardId,
                notification_text: this.messageInfo.notification_text,
                notification_greeting: this.messageInfo.notification_greeting,
                notification_signature: this.messageInfo.notification_signature,
                organization: this.messageInfo.organization,
                confirm_send: this.messageInfo.confirm_send,
                stake_id: this.messageInfo.ward_info.stake_id,
                ward_info: this.messageInfo.ward_info,
                message_state: this.messageInfo.message_state,
                message_id: this.messageInfo.message_id,
                scheduled_delivery_on: this.messageInfo.scheduled_delivery_on,
                temp_contacts: this.messageInfo.temp_contacts,
                segments_sent: this.messageInfo.segments_sent,
                contacts_sent: this.messageInfo.contacts_sent,
                cost: this.messageInfo.cost,
                carrier_fees: this.messageInfo.carrier_fees,
                sub_total: this.messageInfo.sub_total,
                short_urls: this.messageInfo.short_urls,
                alternate_languages: this.messageInfo.alternate_languages,
                contact_id: this.contactId
            };
            try{

                this.disabledButton = true;
                const { data } = await WardApi.sendNotificationText(this.wardId, dataToSend);
                this.notificationResponse = data.NotificationResult;
                if(this.notificationResponse.message_preview==='Message has been queued for sending'){
                    this.$toast.success("Successfully Queued message for sending.");
                    this.$router.push({ name: 'ward-message-list',params: { wardId: this.wardId, stakeId: this.stakeId, initState: this.messageInfo.state}});
                    return;
                }
                this.messageInfo.message_state = data.MessageInfo.message_state;
                this.messageInfo.confirm_send = data.MessageInfo.confirm_send;
                this.sendConfirmed = false;
                this.$refs['confirmation-modal'].show();
            }catch(error){
                handleError(error, "Could not process message");
            }finally{
                this.disabledButton = false;
            }
        },
        async validateMessageText() {
            if (this.messageInfo.organization === undefined || this.messageInfo.notification_text === undefined || this.messageInfo.organization  === null || this.messageInfo.notification_text === null)
                return;
            try {
              const { data } =  await MessageApi.validateMessageText(this.messageInfo);
              if  (data !== undefined || data !== null) {
                if (data.message_encoding !== 'GSM') {
                  this.notGsmMessage = true;
                } else {
                  this.notGsmMessage = false;
                }
                this.total_segments = data.segments;
                this.total_characters = data.total_chars;
              }
              } catch (error) {
                handleError(error, "Could not validate message");
              }

        },
        shouldShowLanguages() {
            if (this.selectedOrganization === null) {
                this.showLanguages = false;
            }
            let selectedOrg = this.organizations.find(x => x.value === this.messageInfo.organization);
            this.defaultLanguage = selectedOrg.default_language;
            if (selectedOrg.message_languages.length === 0){
                this.showLanguages = false;
                return;
            }
            this.showLanguages = true;
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
